import styles from "./Tooltip.module.css";

/**
 * A styled tooltip shown on hover and keyboard focus, in the shared chart-tooltip look: the surface colour with primary text, so
 * it is light on light and dark on dark. It replaces a native `title`, which the browser draws unstyled, late and not at all on
 * touch. The label is hidden from assistive technology, so the control or text it wraps must already carry its name or words.
 * With no label the children render on their own, so a tooltip can be switched off by its label alone.
 * `placement` puts it above or below the content; `align` anchors it to the content's start, centre or end, with the arrow over
 * the content's middle.
 */
export function Tooltip({
  label,
  placement = "above",
  align = "center",
  className,
  style,
  children,
}: {
  label: string | undefined;
  placement?: "above" | "below";
  align?: "start" | "center" | "end";
  /** Extra classes and inline styles for the wrapper, for a caller whose layout sizes the wrapper itself. */
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}): React.JSX.Element {
  if (!label) {
    return <>{children}</>;
  }
  return (
    <span className={className ? `${styles.wrap} ${className}` : styles.wrap} style={style}>
      {children}
      <span className={`${styles.tooltip} ${styles[placement]} ${styles[align]}`} aria-hidden="true">
        {label}
      </span>
    </span>
  );
}
